module.exports = __webpack_public_path__ + "static/media/refresh.db0133f2.svg";